import { render } from "./DepartmentUserSelector.vue?vue&type=template&id=712c59c8&scoped=true"
import script from "./DepartmentUserSelector.vue?vue&type=script&lang=js"
export * from "./DepartmentUserSelector.vue?vue&type=script&lang=js"

import "./DepartmentUserSelector.vue?vue&type=style&index=0&id=712c59c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-712c59c8"]])

export default __exports__